import React from "react";
import { useEffect, useState } from "react";
import { HomeItem, HomeItemImage, H1 } from "./style";
import { Input } from "../../Login/style";
import Button from "../../../Components/Miscellaneous/Button";
import AuthService from "../../../AuthService";
import { InputFile } from "./productCreator/style";
import { FiAlertTriangle, FiImage, FiTrash2, FiPlus, FiSave, FiLink } from "react-icons/fi";
import { toast } from "react-toastify";

export default function HomeEditor() {
    // Scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [image, setImage] = useState('');
    const [homeItems, setHomeItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const fileInputRefs = React.useRef([]);

    useEffect(() => {
        fetchHomeData();
    }, []);

    const fetchHomeData = () => {
        setLoading(true);
        fetch('https://api.rb.beeapp.es/home')
            .then(response => response.json())
            .then(data => {
                setHomeItems(data.slider || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching home data:', error);
                toast.error('Error al cargar los datos');
                setLoading(false);
            });
    };

    const updateSlider = () => {
        if (homeItems.length === 0) {
            toast.error('No hay elementos para guardar');
            return;
        }

        setSaving(true);
        fetch('https://api.rb.beeapp.es/home/slider/' + homeItems[0]._id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            body: JSON.stringify({
                slider: homeItems
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                toast.success('Slider actualizado correctamente');
                setSaving(false);
            })
            .catch(error => {
                console.error(error);
                toast.error('Error al guardar los cambios');
                setSaving(false);
            });
    }

    const handleFileInput = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('image', file);

        toast.info('Subiendo imagen...');

        fetch('https://api.rb.beeapp.es/admin/imageUpload', {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + AuthService.getToken()
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            const newHomeItems = [...homeItems];
            newHomeItems[index].image = "https://cdn.beeapp.es/" + data.imagename;
            setHomeItems(newHomeItems);
            toast.success('Imagen subida correctamente');
        })
        .catch(error => {
            console.error(error);
            toast.error('Error al subir la imagen');
        });
    }

    const addSlideItem = () => {
        const newItem = {
            image: 'https://via.placeholder.com/800x400?text=Nueva+Imagen',
            link: ''
        };
        setHomeItems([...homeItems, newItem]);
        toast.success('Nuevo slide agregado');
    }

    const removeSlideItem = (index) => {
        if (homeItems.length <= 1) {
            toast.error('Debe haber al menos un slide');
            return;
        }

        const newHomeItems = homeItems.filter((_, i) => i !== index);
        setHomeItems(newHomeItems);
        toast.success('Slide eliminado');
    }

    const updateLink = (index, value) => {
        const newHomeItems = [...homeItems];
        newHomeItems[index].link = value;
        setHomeItems(newHomeItems);
    }

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                fontFamily: 'Inter, sans-serif'
            }}>
                <div style={{
                    fontSize: '18px',
                    color: '#6b7280'
                }}>
                    Cargando...
                </div>
            </div>
        );
    }

    return (
        <div style={{
            padding: '32px',
            maxWidth: '1200px',
            margin: 'auto',
            fontFamily: 'Inter, sans-serif'
        }}>
            {/* Header */}
            <div style={{
                marginBottom: '32px',
                borderBottom: '2px solid #e5e7eb',
                paddingBottom: '24px'
            }}>
                <H1 style={{ marginBottom: '8px' }}>Editor de Slider de Inicio</H1>
                <p style={{
                    color: '#6b7280',
                    fontSize: '14px',
                    margin: '0'
                }}>
                    Gestiona las imágenes y enlaces del slider de la página principal
                </p>
            </div>

            {/* Slides List */}
            <div style={{
                display: 'grid',
                gap: '24px',
                marginBottom: '24px'
            }}>
                {homeItems.map((item, index) => {
                    return (
                        <div key={index} style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                            transition: 'all 0.2s ease'
                        }}>
                            {/* Slide Header */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: '0',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#111827'
                                }}>
                                    Slide #{index + 1}
                                </h3>
                                <button
                                    onClick={() => removeSlideItem(index)}
                                    disabled={homeItems.length <= 1}
                                    style={{
                                        padding: '8px 12px',
                                        backgroundColor: homeItems.length <= 1 ? '#f3f4f6' : '#fee2e2',
                                        color: homeItems.length <= 1 ? '#9ca3af' : '#dc2626',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: homeItems.length <= 1 ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (homeItems.length > 1) {
                                            e.target.style.backgroundColor = '#fecaca';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (homeItems.length > 1) {
                                            e.target.style.backgroundColor = '#fee2e2';
                                        }
                                    }}
                                >
                                    <FiTrash2 size={16} />
                                    Eliminar
                                </button>
                            </div>

                            {/* Image Preview and Upload */}
                            <div style={{
                                position: 'relative',
                                marginBottom: '16px',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                border: '2px dashed #e5e7eb',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                                onClick={() => fileInputRefs.current[index]?.click()}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#028322';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e5e7eb';
                                }}
                            >
                                <HomeItemImage
                                    src={item.image}
                                    alt={`Slide ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '300px',
                                        objectFit: 'cover',
                                        display: 'block'
                                    }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    color: '#fff',
                                    padding: '12px 20px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    opacity: '0',
                                    transition: 'opacity 0.2s ease',
                                    pointerEvents: 'none'
                                }}
                                    className="upload-overlay"
                                >
                                    <FiImage size={18} />
                                    Haz click para cambiar imagen
                                </div>
                            </div>

                            <InputFile
                                type="file"
                                ref={(el) => fileInputRefs.current[index] = el}
                                onChange={(e) => handleFileInput(e, index)}
                                style={{ display: 'none' }}
                                accept="image/*"
                            />

                            {/* Link Input */}
                            <div>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    marginBottom: '8px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#374151'
                                }}>
                                    <FiLink size={16} />
                                    Enlace (URL)
                                </label>
                                <Input
                                    type="text"
                                    value={item.link}
                                    onChange={(e) => updateLink(index, e.target.value)}
                                    placeholder="https://ejemplo.com/categoria"
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Inter, sans-serif',
                                        outline: 'none',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#028322'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Action Buttons */}
            <div style={{
                display: 'flex',
                gap: '12px',
                marginTop: '24px'
            }}>
                <Button
                    onClick={addSlideItem}
                    style={{
                        flex: 1,
                        backgroundColor: '#fff',
                        color: '#028322',
                        border: '2px solid #028322',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f0fdf4';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#fff';
                    }}
                >
                    <FiPlus size={18} />
                    Agregar Nuevo Slide
                </Button>

                <Button
                    onClick={updateSlider}
                    disabled={saving}
                    style={{
                        flex: 1,
                        backgroundColor: saving ? '#9ca3af' : '#028322',
                        color: '#fff',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        cursor: saving ? 'not-allowed' : 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(2, 131, 34, 0.2)'
                    }}
                    onMouseEnter={(e) => {
                        if (!saving) {
                            e.target.style.backgroundColor = '#026d1b';
                            e.target.style.boxShadow = '0 4px 8px rgba(2, 131, 34, 0.3)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!saving) {
                            e.target.style.backgroundColor = '#028322';
                            e.target.style.boxShadow = '0 2px 4px rgba(2, 131, 34, 0.2)';
                        }
                    }}
                >
                    <FiSave size={18} />
                    {saving ? 'Guardando...' : 'Guardar Cambios'}
                </Button>
            </div>

            <style>
                {`
                    div:hover .upload-overlay {
                        opacity: 1 !important;
                    }
                `}
            </style>
        </div>
    );
}
